import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHeader from "./SectionHeader";
import SectionBody from "./SectionBody";
import SectionFooter from "./SectionFooter";
import NewsletterSection from "components/NewsletterSection/NewsletterSection";
import React, { FC } from "react";
//import heroRightImage from "images/hero-right-car.png";
import heroRightImage from "images/img.png";

export interface BlogListPageProps {
  className?: string;
}

const BlogListPage: FC<BlogListPageProps> = ({ className = "" }) => {

  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <BgGlassmorphism />

      <div className="container relative">
        {/* SECTION HERO */}
        <SectionHeader
          rightImage={heroRightImage}
          currentPage="Cars"
          listingType={
            <>
            </>
          }
          className="pt-10 pb-24 lg:pb-28 lg:pt-16 "
        />

        {/* SECTION */}
        <SectionBody className="pb-24 lg:pb-28" />

        {/* SECTION 1 */}
        <div className="relative py-16 border-t border-neutral-200 dark:border-neutral-700">
          <SectionFooter
            heading="인기 글 둘러보기"
            subHeading="최신 기술 트렌드를 먼저 만나보세요"
            categoryCardType="card4"
            itemPerRow={4}
            sliderStyle="style1"
            uniqueClassName="ListingCarPage"
          />
        </div>

        {/* SECTION */}
        <NewsletterSection className="py-24 lg:py-28" />
      </div>
    </div>
  );
};

export default BlogListPage;
